<template>
  <v-dialog v-model="showPopup" persistent max-width="520"
    @keydown.passive.enter='doDelete'
    @keydown.passive.esc='doCancel'
  >
    <v-card class="pa-4">
      <v-card-title class="headline justify-center popup-title">
        <span>Are you sure want to delete the warehouse location?</span>
      </v-card-title>

      <v-card-actions class="text-xs-center justify-center">
        <v-btn @click="doCancel" depressed class="cancel-btn small-size">
          Cancel
        </v-btn>
        <v-btn @click="doDelete" depressed class="save-btn small-size">
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'WarehouseMapLocationPopupDelete',
  props: {
    showPopup: {
      type: Boolean,
      required: true
    }
  },
  computed: {
  },
  methods: {
    doCancel() {
      this.$emit('cancel')
    },
    doDelete() {
      this.$emit('delete')
    }
  }
}
</script>
